// React
import React from 'react';
import PropTypes from 'prop-types';

// VDS
import Icon from '@visa/vds-react/icon-styled';
import iconDictionary from './icon-dictionary';
import stylesBuilder from './component.styles';

const { iconStyles } = stylesBuilder();

const CybsIcon = ({
  ariaHidden,
  ariaLabel,
  dataTest,
  name,
  resolution,
  role,
  title,
  ...props
}) => {
  const parsedName = iconDictionary[name] || 'help';
  return (
    <Icon
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : ariaLabel || parsedName}
      customCSS={iconStyles}
      data-test={`${dataTest}-cybsIcon`}
      name={parsedName}
      resolution={resolution}
      role={role}
      title={ariaHidden ? undefined : title || ariaLabel || parsedName}
      {...props}
    />
  );
};

CybsIcon.propTypes = {
  /**
   * Override the default to hide icon from screen readers
   */
  ariaHidden: PropTypes.bool,
  /**
   * @ignore
   */
  ariaLabel: PropTypes.string,
  /**
   * Datatest
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Name of the icon e.g. help
   */
  name: PropTypes.string.isRequired,
  /**
   * Resolution of the icon e.g. low
   */
  resolution: PropTypes.oneOf(['high', 'low', 'tiny']),
  /**
   * A11y role
   */
  role: PropTypes.string,
  /**
   * A11y role
   */
  title: PropTypes.string
};

CybsIcon.defaultProps = {
  ariaHidden: true,
  ariaLabel: undefined,
  resolution: 'low',
  role: undefined,
  title: undefined
};

CybsIcon.displayName = 'CybsIcon';

export { iconDictionary };
export default CybsIcon;
